import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  baseurl = environment.baseUrl
  constructor(private http: HttpClient, private toastr: ToastrService ) { }
  get(endpoint: string, params?: any): Observable<any> {
    // console.log(params)
    if (params == undefined) {
      var url = `${this.baseurl}${endpoint}`;
    }
    else {
      var url = `${this.baseurl}${endpoint}${params}`;
    }
    return this.http.get(url).pipe(
      catchError((error: any) => {
        return throwError(() => error);
      })
    );
  }

  post(endpoint: string, body: any): Observable<any> {
    const url = `${this.baseurl}${endpoint}`;
    return this.http.post(url, body).pipe(
      catchError((error: any) => {
        return throwError(() => error); // Using new signature of throwError
      })
    );
  }
  put(endpoint: string, body: any): Observable<any> {
    const url = `${this.baseurl}${endpoint}`;
    return this.http.put(url, body).pipe(
      catchError((error: any) => {
        return throwError(() => error); // Using new signature of throwError
      })
    );
  }
  delete(endpoint: string, body?: any): Observable<any> {
    console.log(this.baseurl+endpoint,body);
    if(body == undefined){
      body =''
    }
    const url = `${this.baseurl}${endpoint}`;
    return this.http.delete(url, {body:body}).pipe(
      catchError((error: any) => {
        return throwError(() => error); // Using new signature of throwError
      })
    );
  }
 downloadFile(endpoint: string, params?: any): Observable<Blob> {
   if (params == undefined) {
      var url = `${this.baseurl}${endpoint}`;
    }
    else {
      var url = `${this.baseurl}${endpoint}${params}`;
    }
    return this.http.get(url,{ responseType: 'blob' })
      // return this.http.get(url, { responseType: 'blob' });
    }

    

   // alert common function
  
    showToast(icon: SweetAlertIcon, title: string): void {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
  
      });
      Toast.fire({
        icon: icon,
        title: title
      });
    }

    showModernToast(method: 'success' | 'error' | 'info' | 'warning', message: string): void {
      const toast = this.toastr[method](message, '', {
      timeOut: 5000,
      tapToDismiss: true,
      closeButton: true,
    });
    }


}
